import config from './config'
import logger from 'redux-logger'
import { Action, combineReducers } from 'src/framework'
import { appEpics } from 'src/app.epics'
import { applyMiddleware, createStore } from 'redux'
import { AuthService, AuthStorage } from './services/auth.service'
import { coachHomeEpics } from 'src/home/coach/coach-home.epics'
import { coachHomeReducer, CoachHomeState, initialCoachHomeState } from 'src/home/coach/coach-home.reducer'
import { combineEpics, createEpicMiddleware } from 'redux-observable'
import { companiesReducer, CompaniesState, initialCompaniesState } from 'src/companies-components/companies.reducer'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { createBrowserHistory } from 'history'
import { createCompanyEpics } from 'src/companies-components/create-company/create-company.epics'
import {
  createCompanyReducer,
  CreateCompanyState,
  initialCreateCompanyState
} from 'src/companies-components/create-company/create-company.reducer'
import { createUserEpics } from 'src/users-components/create-user/create-user.epics'
import {
  createUserReducer,
  CreateUserState,
  initialCreateUserState
} from 'src/users-components/create-user/create-user.reducer'
import { DSService } from './services/ds.service'
import { fetchReducer, FetchState, initialFetchState } from 'src/framework/fetch-reducer'
import { finalizeRegisterEpics } from 'src/users-components/finalize-register/finalize-register.epics'
import {
  finalizeRegisterReducer,
  FinalizeRegisterState,
  initialFinalizeRegisterState
} from 'src/users-components/finalize-register/finalize-register.reducer'
import {
  lostPasswordReducer,
  LostPasswordState,
  initialLostPasswordState
} from 'src/users-components/lost-password/lost-password.reducer'
import {
  initialInviteUserTestState,
  inviteUserTestReducer,
  InviteUserTestState
} from 'src/tests-components/invite-user/invite-user-test.reducer'
import { initialLoginState, loginReducer, LoginState } from 'src/users-components/login/login.reducer'
import { initialPaymentState, paymentReducer, PaymentState } from 'src/payment/payment.reducer'
import {
  initialStructureHomeState,
  structureHomeReducer,
  StructureHomeState
} from 'src/home/structure/structure-home.reducer'
import { initialTestPageState, testPageReducer, TestPageState } from 'src/tests-components/test-page/test-page.reducer'
import {
  initialTestsNamesState,
  testsNamesReducer,
  TestsNamesState
} from 'src/tests-components/select-tests-names/testsNames.reducer'
import { initialTestsState, testsReducer, TestsState } from 'src/tests-components/select-tests/tests.reducer'
import {
  initialUpdateCompanyState,
  updateCompanyReducer,
  UpdateCompanyState
} from 'src/companies-components/update-company/update-company.reducer'
import {
  initialUpdateMyCompanyState,
  updateMyCompanyReducer,
  UpdateMyCompanyState
} from './companies-components/update-my-company/update-my-company.reducer'
import {
  initialUpdateTestState,
  updateTestReducer,
  UpdateTestState
} from 'src/tests-components/update-test/update-test.reducer'
import { inviteUserTestEpics } from 'src/tests-components/invite-user/invite-user-test.epics'
import { LocalStorageService } from './services/local-storage'
import { loginEpics } from 'src/users-components/login/login.epics'
import { paymentEpics } from 'src/payment/payment.epics'
import { routerMiddleware, RouterState, connectRouter } from 'connected-react-router'
import { structureHomeEpics } from 'src/home/structure/structure-home.epics'
import { testPageEpics } from 'src/tests-components/test-page/test-page.epics'
import { testsEpics } from 'src/tests-components/select-tests/tests.epics'
import { testsNamesEpics } from 'src/tests-components/select-tests-names/testsNames.epics'
import { updateCompanyEpics } from 'src/companies-components/update-company/update-company.epics'
import { updateMyCompanyEpics } from './companies-components/update-my-company/update-my-company.epics'
import { updateTestEpics } from 'src/tests-components/update-test/update-test.epics'
import { MeState, initialMeState, meReducer } from './users-components/me/me.reducer'
import { meEpics } from './users-components/me/me.epics'
import {
  GiftCreditsState,
  initialGiftCreditsState,
  giftCreditsReducer
} from './credits-components/gift-credits/gift-credits.reducer'
import { giftCreditsEpics } from './credits-components/gift-credits/gift-credits.epics'
import { lostPasswordEpics } from "./users-components/lost-password/lost-password.epics"

// ----------

export interface State {
  fetch: FetchState
  login: LoginState
  tests: TestsState
  testsNames: TestsNamesState
  payment: PaymentState
  testPage: TestPageState
  giftCredits: GiftCreditsState
  updateTest: UpdateTestState
  coachHome: CoachHomeState
  finalizeRegister: FinalizeRegisterState
  lostPassword: LostPasswordState
  structureHome: StructureHomeState
  companies: CompaniesState
  inviteUserTest: InviteUserTestState
  createCompany: CreateCompanyState
  updateCompany: UpdateCompanyState
  updateMyCompany: UpdateMyCompanyState
  me: MeState
  createUser: CreateUserState
  router: RouterState
}

export const history = createBrowserHistory()

const intitialState: State = {
  fetch: initialFetchState,
  login: initialLoginState,
  tests: initialTestsState,
  testsNames: initialTestsNamesState,
  payment: initialPaymentState,
  testPage: initialTestPageState,
  giftCredits: initialGiftCreditsState,
  coachHome: initialCoachHomeState,
  structureHome: initialStructureHomeState,
  finalizeRegister: initialFinalizeRegisterState,
  lostPassword: initialLostPasswordState,
  updateTest: initialUpdateTestState,
  companies: initialCompaniesState,
  inviteUserTest: initialInviteUserTestState,
  createCompany: initialCreateCompanyState,
  updateCompany: initialUpdateCompanyState,
  updateMyCompany: initialUpdateMyCompanyState,
  me: initialMeState,
  createUser: initialCreateUserState,
  router: { location: history.location, action: history.action }
}

const reducer = combineReducers<State, Action<any>>(
  {
    fetch: fetchReducer,
    login: loginReducer,
    tests: testsReducer as any,
    testsNames: testsNamesReducer as any,
    payment: paymentReducer as any,
    testPage: testPageReducer as any,
    giftCredits: giftCreditsReducer as any,
    coachHome: coachHomeReducer as any,
    structureHome: structureHomeReducer as any,
    finalizeRegister: finalizeRegisterReducer as any,
    lostPassword: lostPasswordReducer as any,
    updateTest: updateTestReducer as any,
    companies: companiesReducer as any,
    inviteUserTest: inviteUserTestReducer as any,
    createCompany: createCompanyReducer as any,
    updateCompany: updateCompanyReducer as any,
    updateMyCompany: updateMyCompanyReducer as any,
    me: meReducer as any,
    createUser: createUserReducer as any,
    router: connectRouter(history) as any
  },
  intitialState
)

export interface Deps {
  dsService: DSService
  authService: AuthService
}

const rootEpic = combineEpics(
  appEpics,
  loginEpics,
  testsEpics,
  testsNamesEpics,
  paymentEpics,
  testPageEpics,
  giftCreditsEpics,
  coachHomeEpics,
  structureHomeEpics,
  finalizeRegisterEpics,
  lostPasswordEpics,
  updateTestEpics,
  updateMyCompanyEpics,
  meEpics,
  updateCompanyEpics,
  createCompanyEpics,
  createUserEpics,
  inviteUserTestEpics
)

const deps = (): Deps => {
  const dsService = new DSService(config.wsUrl)
  const authService = new AuthService(new AuthStorage(new LocalStorageService()), dsService)

  return {
    dsService,
    authService
  }
}

const fakeDeps = (): Deps => {
  const dsService = new DSService(config.wsUrl)
  const authService = new AuthService(new AuthStorage(new LocalStorageService()), dsService)

  return {
    dsService,
    authService
  }
}

const gatherDeps = process.env['REACT_APP_ISOLATE'] !== undefined ? fakeDeps : deps

const epicMiddleware = createEpicMiddleware<Action<any>>({
  dependencies: gatherDeps()
})

const historyMiddleware = routerMiddleware(history)

export const store = createStore(
  (state: State | undefined, action: Action<any>) => reducer(action)(state),
  composeWithDevTools(applyMiddleware(epicMiddleware, logger, historyMiddleware))
)

epicMiddleware.run(rootEpic)



// WEBPACK FOOTER //
// ./src/app.store.ts